export default __webpack_public_path__ + "locales/si/Ldap.json?hash=0f66ec27bc9c2ebb9355b181cc6fd288";